import React, { ReactElement } from "react";

import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import CreateHouseholdForm from "./CreateHouseholdForm";

interface Props {
  isOpen: boolean;
  closeModal: () => void;
}

const CreateHouseholdsModal: React.FC<Props> = ({
  isOpen,
  closeModal,
}: Props): ReactElement => {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal}>
      <Text variant="title1">Create New Household</Text>
      <Text variant="body">
        Enter household details and point of contact information
      </Text>

      <CreateHouseholdForm onCancel={closeModal} onSuccess={closeModal} />
    </Modal>
  );
};

export default CreateHouseholdsModal;
